"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _lcHttp = _interopRequireDefault(require("lc-http"));
var _LocalStorageHelpers = require("./LocalStorageHelpers");
function createNewLinkToken(_x, _x2) {
  return _createNewLinkToken.apply(this, arguments);
}
function _createNewLinkToken() {
  _createNewLinkToken = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(tokenUrl, config) {
    var createToken, token;
    return _regenerator["default"].wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            (0, _LocalStorageHelpers.destroyLocalStorageLinkToken)();
            createToken = /*#__PURE__*/function () {
              var _ref = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
                var response;
                return _regenerator["default"].wrap(function _callee$(_context) {
                  while (1) {
                    switch (_context.prev = _context.next) {
                      case 0:
                        _context.next = 2;
                        return _lcHttp["default"].post(tokenUrl, config)["catch"](function () {
                          return undefined;
                        });
                      case 2:
                        response = _context.sent;
                        return _context.abrupt("return", response && response.data && response.data.content && response.data.content.linkToken);
                      case 4:
                      case "end":
                        return _context.stop();
                    }
                  }
                }, _callee);
              }));
              return function createToken() {
                return _ref.apply(this, arguments);
              };
            }();
            _context2.next = 4;
            return createToken();
          case 4:
            token = _context2.sent;
            if (token) {
              (0, _LocalStorageHelpers.putLocalStorageLinkToken)(token);
            }
            return _context2.abrupt("return", token);
          case 7:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _createNewLinkToken.apply(this, arguments);
}
function generateLinkToken(_x3, _x4, _x5) {
  return _generateLinkToken.apply(this, arguments);
}
function _generateLinkToken() {
  _generateLinkToken = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3(createFresh, tokenUrl, config) {
    var token;
    return _regenerator["default"].wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            if (createFresh) {
              _context3.next = 4;
              break;
            }
            token = (0, _LocalStorageHelpers.getLocalStorageLinkToken)();
            if (!token) {
              _context3.next = 4;
              break;
            }
            return _context3.abrupt("return", token);
          case 4:
            return _context3.abrupt("return", createNewLinkToken(tokenUrl, config));
          case 5:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _generateLinkToken.apply(this, arguments);
}
var _default = generateLinkToken;
exports["default"] = _default;
